<script setup>
import { computed } from 'vue'
import { useMeta } from 'vue-meta'
import AlertModal from '@/user/dialogs/AlertModal.vue'
import { Footer } from '@/user/components/organisms'
import Loader from '@/user/components/atoms/commons/Loader.vue'
import store from '@/user/store'

const alertModal = computed(() => store.getters['AlertStore/alertModal'])

const handleAlertModalConfirm = () => {
  if (alertModal.value.onConfirm) {
    alertModal.value.onConfirm()
  }
}

useMeta({
  title: 'NHN CLOUD 교육센터',
  keywords: '',
  description: '',
  og: {
    title: 'NHN CLOUD 교육센터',
    url: location.href,
    keywords: '',
    description: '',
  },
})
</script>
<template>
  <metainfo />
  <router-view />
  <Footer />
  <Loader />
  <AlertModal
    v-model="alertModal.show"
    :message="alertModal.message"
    :on-confirm="handleAlertModalConfirm"
    :vertical-align="alertModal.verticalAlign" />
</template>
<style scoped lang="scss">
#container::after {
  content: '';
  position: fixed;
  left: 0;
  top: 0;
  width: 1px;
  height: 1px;
  z-index: -1;
  visibility: hidden;
  background-image: url('./assets/img/ico_loading.gif');
}
</style>
